import AXIOS from '@/utils/$axios';

export const getCondition = payload =>
    AXIOS.post('/lws/render/condition', payload);
// 获取新人大礼包
export const getProductCouponGift = params =>
    AXIOS.get(`/hdc-admin/hdc/product/coupon/gift`, { params });

// 渲染券免费领取
export const postProductCouponFree = data =>
    AXIOS.post(`/hdc-admin/hdc/product/coupon/free`, data);
